import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-unsubscribe',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './unsubscribe.component.html',
  styleUrl: './unsubscribe.component.css'
})
export class UnsubscribeComponent implements OnInit {

  loading: boolean = true;
  success: boolean = false;
  error: boolean = false;
  message: string = '';
  username: string = '';

  private token: string = '';
  private calendlyUrl: string = 'https://calendly.com/dwip_shah/30min';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'] || '';
      if (this.token) {
        this.processUnsubscribe();
      } else {
        this.loading = false;
        this.error = true;
        this.message = 'No unsubscribe token provided.';
      }
    });
  }

  processUnsubscribe(): void {
    this.loading = true;

    this.http.post<any>('/backend/notifications/unsubscribe', {
      token: this.token
    }).subscribe({
      next: (res) => {
        this.loading = false;
        this.success = true;
        this.error = false;
        this.username = res.payload?.username || '';
        this.message = res.message || 'You have been unsubscribed from Quant IP Portfolios notification emails.';
      },
      error: (err) => {
        this.loading = false;
        this.success = false;
        this.error = true;
        this.message = err.error?.message || 'Failed to process unsubscribe request. The link may be invalid or expired.';
      }
    });
  }

  openCalendly(): void {
    window.open(this.calendlyUrl, '_blank');
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
